var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LabeledSelect',_vm._b({attrs:{"value":_vm.value,"mode":_vm.mode,"multiple":true,"options":_vm.namespaceOptions,"label":_vm.label,"tooltip":_vm.tooltip,"hover-tooltip":!!_vm.tooltip},on:{"input":(e) => _vm.$emit('input', e)}},'LabeledSelect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }